module.exports = __webpack_public_path__ + "img/concept_en.d375bc32.png";